export const APPLICANT_TRAINING_RESULT_START = 'APPLICANT|APPLICANT_TRAINING_RESULT_START';
export const APPLICANT_TRAINING_RESULT_SUCCESS = 'APPLICANT|APPLICANT_TRAINING_RESULT_SUCCESS';
export const APPLICANT_TRAINING_RESULT_FAIL = 'APPLICANT|APPLICANT_TRAINING_RESULT_FAIL';

export const APPLICANT_ACC = 'APPLICANT|APPLICANT_ACTIVE_SUCCESS';
